import {
    get_scadenzeMezzo,
    get_scadenzaMezzo,
    create_scadenzaMezzo,
    update_scadenzaMezzo,
    completa_scadenzaMezzo,
    duplica_scadenzaMezzo,
    elimina_scadenzaMezzo,
} from "@/api/api.scadenzamezzo.js";

const scadenzeMezzo = {
    namespaced: true,

    state: {
        lista: [],
        corrente: null,
    },

    mutations: {
        SET_LISTA: (state, lista) => {
            state.lista = lista;
        },
        SET_CORRENTE: (state, s) => {
            state.corrente = s;
        },
    },

    actions: {
        carica({ commit }, filtri) {
            return new Promise((resolve, reject) => {
                get_scadenzeMezzo(filtri).then(resp => {
                    commit("SET_LISTA", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        caricaDettaglio({ commit }, id) {
            return new Promise((resolve, reject) => {
                get_scadenzaMezzo(id).then(resp => {
                    commit("SET_CORRENTE", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        pianifica({ dispatch }, dati) {
            return new Promise((resolve, reject) => {
                create_scadenzaMezzo(dati).then(resp => {
                    dispatch("carica", { mezzoId: dati.mezzoId });
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        riprogramma({ dispatch }, { id, dati, mezzoId }) {
            return new Promise((resolve, reject) => {
                update_scadenzaMezzo(id, dati).then(resp => {
                    dispatch("carica", { mezzoId });
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        // Wizard di chiusura: note, foto, flag automazione. Niente "inizia":
        // una scadenza mezzo passa direttamente da Pianificata a Completata.
        completa({ dispatch }, { id, dati, mezzoId }) {
            return new Promise((resolve, reject) => {
                completa_scadenzaMezzo(id, dati).then(resp => {
                    dispatch("carica", { mezzoId });
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        elimina({ dispatch }, { id, mezzoId }) {
            return new Promise((resolve, reject) => {
                elimina_scadenzaMezzo(id).then(resp => {
                    dispatch("carica", { mezzoId });
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        duplica({ dispatch }, { id, mezzoId }) {
            return new Promise((resolve, reject) => {
                duplica_scadenzaMezzo(id).then(resp => {
                    dispatch("carica", { mezzoId });
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },
    },

    getters: {
        lista: state => state.lista,
        corrente: state => state.corrente,
    },
};

export default scadenzeMezzo;
